import { Build, HomeWork, SquareFoot } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate, Route } from 'react-router-dom';
import { TrcApp } from 'thermia-react-container';
import { setConfig } from './config';
import NoGuideError from './pages/noGuide';
import TroubleshootSearch from './pages/troubleshootSearch';
import Guide from './pages/troubleshootView';
import { GuideType } from './types/types';

const App = () => {
  const { t } = useTranslation('troubleshoot');

  document.title = t('troubleshoot.general.siteTitle');

  return (
    <TrcApp
      configPath="/config/config.json"
      setConfig={setConfig}
      title={
        <>
          <Typography fontWeight={'bold'}>{t('troubleshoot.general.appTitle')}:&nbsp;</Typography>
          <Typography style={{ fontStyle: 'italic' }}>{t('troubleshoot.general.appTitleDescription')}</Typography>
        </>
      }
      logoLink={'https://partnerlogin.thermia.se/sv/home.html'}
      logoText={'PARTNERLOGIN'}
      requiredPermissions={['ts_rd']}
      contentMaxWidth={'xl'}
      routes={
        <>
          <Route path="/" element={<Navigate to={`/troubleshoot-guides`} replace />} />
          <Route path="/noGuide" element={<NoGuideError />} />

          <Route
            path="/troubleshoot-guides"
            element={<TroubleshootSearch key={'guides'} title={t('troubleshoot.general.troubleshoot')} type={GuideType.TROUBLESHOOT} />}
          />
          <Route path="/troubleshoot-guides/:id" element={<Guide type={GuideType.TROUBLESHOOT} />} />

          <Route
            path="/installations-functions"
            element={
              <TroubleshootSearch key={'functions'} title={t('troubleshoot.general.functions')} type={GuideType.INSTALLATIONS_AND_FUNCTIONS} />
            }
          />
          <Route path="/installations-functions/:id" element={<Guide type={GuideType.INSTALLATIONS_AND_FUNCTIONS} />} />

          <Route
            path="/projectplanning-dimensioning"
            element={
              <TroubleshootSearch
                key={'projectplanning'}
                title={t('troubleshoot.general.projectplanning')}
                type={GuideType.PROJECTPLANNING_AND_DIMENSIONING}
              />
            }
          />
          <Route path="/projectplanning-dimensioning/:id" element={<Guide type={GuideType.PROJECTPLANNING_AND_DIMENSIONING} />} />
        </>
      }
      tabs={[
        {
          icon: Build,
          label: t('troubleshoot.general.troubleshoot'),
          path: 'troubleshoot-guides'
        },
        {
          icon: HomeWork,
          label: t('troubleshoot.general.functions'),
          path: 'installations-functions'
        },
        {
          icon: SquareFoot,
          label: t('troubleshoot.general.projectplanning'),
          path: 'projectplanning-dimensioning'
        }
      ]}
    />
  );
};

export default App;
